import React from "react";
import BulasikMakinaParlaticisi from "../Components/product/BulasikMakinaParlaticisi";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import ProductSEO from "../Components/common/ProductSEO";

function BulasikMakinaParlaticisiPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Makina Parlatıcısı (Durulama)"
                description="Durulama aşamasında su lekelerini önler ve parlak sonuç sağlar."
                slug="bulasikmakinaparlaticisi"
                imagePath="assets/images/20-kg/7.webp"
            />
            <PageHeader title={t("BULAŞIK MAKİNA PARLATICISI (DURULAMA)")} />
            <BulasikMakinaParlaticisi />
        </>
    );
}

export default BulasikMakinaParlaticisiPage;